import { useQuery } from "@tanstack/react-query";
import { getNetWorth } from "../../lib/api-modules/networth.js";
import { usePreferences } from "../../lib/preferences.js";
import { fiAssetsCents as computeFiAssets } from "../../lib/util/retirement-plan.js";

/**
 * Composite hook every `/fire/*` sub-page needs.
 *
 * `fiAssetsCents` is net worth minus money earmarked for others (529,
 * UTMA, donor-advised funds), because FIRE math must only count what can
 * actually fund retirement. `byAccountType` drives the tax estimate.
 *
 * The query key matches the dashboard's so we share its TanStack Query
 * cache: no duplicate network call when navigating between pages.
 */
export function useFireContext(): {
  hideValues: boolean;
  fiAssetsCents: number;
  byAccountType: Readonly<Record<string, number>> | undefined;
} {
  const { privacyMode } = usePreferences();
  const networthQuery = useQuery({
    queryKey: ["networth", "24m"],
    queryFn: () => getNetWorth("24m"),
  });
  const latest = networthQuery.data?.latest;
  return {
    hideValues: privacyMode,
    fiAssetsCents: latest ? computeFiAssets(latest) : 0,
    byAccountType: latest?.by_account_type,
  };
}
